import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { addTemplateAPI } from "../../api/api";
import { useNavigate } from "react-router-dom";

function AssessmentForm() {
  const navigate = useNavigate();
  const [questions, setQuestions] = useState([
    {
      id: 1,
      questionText: "",
      options: [{ text: "", points: 0 }],
      selectType: "single",
    },
  ]);

  const [frequency, setFrequency] = useState("");
  const [title, setTitle] = useState("");

  const handleTitleChange = (e) => {
    setTitle(e.target.value);
  };

  const handleFrequencyChange = (e) => {
    setFrequency(e.target.value);
  };

  const handleQuestionChange = (id, value) => {
    setQuestions(
      questions.map((q) => (q.id === id ? { ...q, questionText: value } : q))
    );
  };

  const handleOptionChange = (questionId, optionIndex, value) => {
    setQuestions(
      questions.map((q) =>
        q.id === questionId
          ? {
              ...q,
              options: q.options.map((option, index) =>
                index === optionIndex ? { ...option, text: value } : option
              ),
            }
          : q
      )
    );
  };

  const handlePointsChange = (questionId, optionIndex, points) => {
    setQuestions(
      questions.map((q) =>
        q.id === questionId
          ? {
              ...q,
              options: q.options.map((option, index) =>
                index === optionIndex
                  ? { ...option, points: Number(points) }
                  : option
              ),
            }
          : q
      )
    );
  };

  const handleSelectTypeChange = (id, value) => {
    setQuestions(
      questions.map((q) => (q.id === id ? { ...q, selectType: value } : q))
    );
  };

  const addOption = (questionId) => {
    setQuestions(
      questions.map((q) =>
        q.id === questionId
          ? {
              ...q,
              options: [...q.options, { text: "", points: 0 }],
            }
          : q
      )
    );
  };

  const addQuestion = () => {
    const newQuestion = {
      id: questions.length + 1,
      questionText: "",
      options: [{ text: "", points: 0 }],
      correctOption: "",
      selectType: "single",
    };
    setQuestions([...questions, newQuestion]);
  };

  const removeQuestion = (questionId) => {
    setQuestions(questions.filter((q) => q.id !== questionId));
  };

  const removeOption = (questionId, optionIndex) => {
    setQuestions(
      questions.map((q) =>
        q.id === questionId
          ? {
              ...q,
              options: q.options.filter((_, index) => index !== optionIndex),
            }
          : q
      )
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const doctor = JSON.parse(localStorage.getItem("doctor"));
    const doctorId = doctor._id;

    const data = {
      title,
      doctorId,
      frequency,
      questions,
    };

    try {
      const res = await addTemplateAPI(data);
      // Resetting form state
      setQuestions([
        {
          id: 1,
          questionText: "",
          options: [{ text: "", points: 0 }],
          selectType: "single",
        },
      ]);
      setFrequency("");
      setTitle("");
      // Alert user of success
      alert("Assessment submitted successfully!");
      // Redirect to another page, e.g., '/assessment-page'
      navigate("/assessment-page");
    } catch (error) {
      // Alert user of failure
      alert("Failed to submit assessment.");
    }
  };

  const formStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
  };

  const questionBlockStyle = {
    marginBottom: "20px",
    border: "1px solid #ccc",
    padding: "10px",
    borderRadius: "5px",
    width: "90%",
  };

  const questionInputStyle = {
    width: "100%",
    padding: "10px",
    margin: "10px 0",
    borderRadius: "5px",
    border: "1px solid #ccc",
  };

  const optionInputStyle = {
    width: "70%",
    padding: "10px",
    margin: "5px 0",
    borderRadius: "5px",
    border: "1px solid #ccc",
    display: "block",
    backgroundColor: "transparent",
  };

  const addButtonStyle = {
    padding: "10px 20px",
    margin: "10px",
    cursor: "pointer",
    borderRadius: "5px",
    border: "none",
    backgroundColor: "transparent",
    color: "black",
  };
  const submitButtonStyle = {
    padding: "10px 20px",
    cursor: "pointer",
    borderRadius: "5px",
    border: "none",
    backgroundColor: "grey",
    color: "white",
  };
  const questionWrapperStyle = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  };

  // Other styles...

  const removeButtonStyle = {
    cursor: "pointer",
    color: "#ff0000",
    border: "none",
    background: "none",
    fontWeight: "bold",
    fontSize: "1.2rem",
  };

  return (
    <div>
      <p style={{ margin: 20, fontSize: "20px" }}>Assessment Form</p>
      <button
        className="backButton"
        style={{ padding: 0, margin: 16, float: "left" }}
        onClick={() => (window.location.href = "/assessment-page")}
      >
        <FontAwesomeIcon icon={faArrowLeft} /> Back
      </button>
      <form onSubmit={handleSubmit} style={formStyle}>
        <div
          style={{
            marginBottom: "20px",
            border: "1px solid #ccc",
            padding: "10px",
            borderRadius: "5px",
            width: "90%",
          }}
        >
          <p>What is the title of the assessment?</p>
          <input
            type="text"
            value={title}
            onChange={handleTitleChange}
            style={{
              width: "100%",
              padding: "10px",
              margin: "10px 0",
              borderRadius: "5px",
              border: "1px solid #ccc",
            }}
            placeholder="Enter assessment title"
          />
        </div>

        <div style={questionBlockStyle}>
          <p>What is the frequency of this test?</p>
          <select
            value={frequency}
            onChange={handleFrequencyChange}
            style={questionInputStyle}
          >
            <option value="">Select Frequency</option>
            <option value="every week">Every Week</option>
            <option value="every other week">Every Other Week</option>
            <option value="every month">Every Month</option>
            <option value="every other month">Every Other Month</option>
          </select>
        </div>

        {questions.map((question, qIndex) => (
          <div key={question.id} style={questionBlockStyle}>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <input
                type="text"
                placeholder={`Question ${qIndex + 1}`}
                value={question.questionText}
                onChange={(e) =>
                  handleQuestionChange(question.id, e.target.value)
                }
                style={questionInputStyle}
              />
              <button
                type="button"
                onClick={() => removeQuestion(question.id)}
                style={addButtonStyle}
              >
                X
              </button>
              <select
                value={question.selectType}
                onChange={(e) =>
                  handleSelectTypeChange(question.id, e.target.value)
                }
                style={{ marginLeft: "auto", backgroundColor: "transparent" }}
              >
                <option value="single">Single Select</option>
                <option value="multi">Multi Select</option>
              </select>
            </div>

            {question.options.map((option, oIndex) => (
              <div key={oIndex} style={questionWrapperStyle}>
                <input
                  type="text"
                  placeholder={`Option ${oIndex + 1}`}
                  value={option.text}
                  onChange={(e) =>
                    handleOptionChange(question.id, oIndex, e.target.value)
                  }
                  style={optionInputStyle}
                />
                <input
                  type="number"
                  placeholder="Points"
                  value={option.points}
                  onChange={(e) =>
                    handlePointsChange(question.id, oIndex, e.target.value)
                  }
                  style={{ ...optionInputStyle, width: "10%" }}
                />
                <button
                  type="button"
                  onClick={() => removeOption(question.id, oIndex)}
                  style={addButtonStyle}
                >
                  X
                </button>
              </div>
            ))}
            <button
              type="button"
              onClick={() => addOption(question.id)}
              style={addButtonStyle}
            >
              Add Option
            </button>
          </div>
        ))}
        <button type="button" onClick={addQuestion} style={addButtonStyle}>
          Add Question
        </button>
        <button type="submit" style={submitButtonStyle}>
          Submit
        </button>
      </form>
    </div>
  );
}

export default AssessmentForm;
